import React, { useState, useEffect, useCallback } from 'react';
import './GastosData.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave, faPlus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

export default function NewGastoModal({ isOpen, onClose, onGastoCreado, onAbrirNuevaCategoria }) {
    const [descripcion, setDescripcion] = useState('');
    const [monto, setMonto] = useState('');
    const [categoria, setCategoria] = useState('General');
    const [idCategoriaGasto, setIdCategoriaGasto] = useState('');
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [nota, setNota] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [guardando, setGuardando] = useState(false);

    const cargarCategorias = useCallback(async () => {
        try {
            const res = await fetch(`${baseURL}/categoriaGastoGet.php`);
            const data = await res.json();
            if (data && data.categorias) {
                setCategorias(data.categorias);
                if (data.categorias.length > 0 && !idCategoriaGasto) {
                    setCategoria(data.categorias[0].categoria);
                    setIdCategoriaGasto(data.categorias[0].idCategoriaGasto);
                }
            }
        } catch (e) {
            console.error(e);
        }
    }, [idCategoriaGasto]);

    useEffect(() => {
        if (isOpen) {
            cargarCategorias();
        }
    }, [isOpen, cargarCategorias]);

    const handleCategoriaSelect = (e) => {
        const id = e.target.value;
        setIdCategoriaGasto(id);
        const encontrada = categorias.find(c => String(c.idCategoriaGasto) === String(id));
        if (encontrada) {
            setCategoria(encontrada.categoria);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const numMonto = parseFloat(monto);
        if (!descripcion.trim()) {
            toast.warn('Ingresa el concepto o descripción del gasto');
            return;
        }
        if (isNaN(numMonto) || numMonto <= 0) {
            toast.warn('Ingresa un monto válido mayor a 0');
            return;
        }

        setGuardando(true);
        try {
            const payload = {
                descripcion: descripcion.trim(),
                monto: numMonto,
                categoria: categoria,
                idCategoriaGasto: idCategoriaGasto || null,
                fecha: fecha,
                nota: nota.trim()
            };

            const res = await fetch(`${baseURL}/gastoPost.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            setGuardando(false);

            if (data.mensaje) {
                Swal.fire({
                    title: '¡Gasto registrado!',
                    text: `Se ha registrado el gasto por ${descripcion}`,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setDescripcion('');
                setMonto('');
                setNota('');
                if (onGastoCreado) onGastoCreado();
                onClose();
            } else {
                toast.error(data.error || 'No se pudo guardar el gasto');
            }
        } catch (err) {
            setGuardando(false);
            console.error(err);
            toast.error('Error de red al registrar el gasto');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modalGastoOverlay">
            <div className="modalGastoContent">
                <div className="modalGastoTop">
                    <h3>💸 Registrar Nuevo Gasto</h3>
                    <button className="btnCloseModalGasto" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="formGasto">
                    <div className="formField">
                        <label>Descripción / Concepto:</label>
                        <input
                            type="text"
                            placeholder="Ej: Pago de Luz (Electricidad), Factura de carne, etc."
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>

                    <div className="formRowGrid">
                        <div className="formField">
                            <label>Monto:</label>
                            <input
                                type="number"
                                step="0.01"
                                placeholder="0.00"
                                value={monto}
                                onChange={(e) => setMonto(e.target.value)}
                                required
                            />
                        </div>

                        <div className="formField">
                            <label>Fecha del gasto:</label>
                            <input
                                type="date"
                                value={fecha}
                                onChange={(e) => setFecha(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="formField">
                        <div className="catLabelRow">
                            <label>Categoría de Gasto:</label>
                            {onAbrirNuevaCategoria && (
                                <button
                                    type="button"
                                    className="btnNuevaCatLink"
                                    onClick={onAbrirNuevaCategoria}
                                >
                                    <FontAwesomeIcon icon={faPlus} /> Nueva Categoría
                                </button>
                            )}
                        </div>
                        <select
                            value={idCategoriaGasto}
                            onChange={handleCategoriaSelect}
                            className="selectGasto"
                        >
                            {categorias.map(cat => (
                                <option key={cat.idCategoriaGasto} value={cat.idCategoriaGasto}>
                                    {cat.categoria}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="formField">
                        <label>Nota o Comprobante (opcional):</label>
                        <input
                            type="text"
                            placeholder="Nº de factura, proveedor, observación..."
                            value={nota}
                            onChange={(e) => setNota(e.target.value)}
                        />
                    </div>

                    <div className="modalGastoActions">
                        <button type="button" className="btnCancelarGasto" onClick={onClose} disabled={guardando}>
                            Cancelar
                        </button>
                        <button type="submit" className="btnGuardarGasto" disabled={guardando}>
                            <FontAwesomeIcon icon={faSave} /> {guardando ? 'Guardando...' : 'Registrar Gasto'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
